<div class="flex flex-col gap-4 w-full flex-1 min-h-0 h-full relative" (wheel)="onWheel($event)">
  <!-- En-tête de calendrier -->
  <aura-calendar-header
    class="shrink-0"
    [currentDate]="currentDate()"
    [view]="view()"
    [events]="visibleEvents()"
    [(sources)]="sources"
    [settings]="settings()"
    (previous)="onPrevious()"
    (next)="onNext()"
    (today)="onToday()"
    (viewChange)="onViewChange($event)"
    (sourceToggle)="sourceToggle.emit($event)"
    (openSettings)="onOpenSettings()"
  />

  <!-- Indicateur de chargement superposé -->
  @if (isLoading()) {
    <div
      class="absolute inset-0 z-40 bg-neutral-1/60 backdrop-blur-2xs flex items-center justify-center rounded-xl min-h-[300px]"
    >
      <mat-spinner diameter="36"></mat-spinner>
    </div>
  }

  <!-- Vues du calendrier -->
  @switch (view()) {
    @case ('month') {
      <aura-calendar-month-view
        class="flex flex-col flex-1 min-h-0 w-full h-full"
        [currentDate]="currentDate()"
        [events]="visibleEvents()"
        [settings]="settings()"
        (eventClick)="onEventClicked($event)"
        (slotClick)="onSlotClicked($event)"
      />
    }

    @case ('week') {
      <aura-calendar-week-view
        class="flex flex-col flex-1 min-h-0 w-full h-full"
        [currentDate]="currentDate()"
        [events]="visibleEvents()"
        [settings]="settings()"
        (eventClick)="onEventClicked($event)"
        (slotClick)="onSlotClicked($event)"
      />
    }

    @case ('list') {
      <aura-calendar-list-view
        class="flex flex-col flex-1 min-h-0 w-full h-full overflow-y-auto"
        [currentDate]="currentDate()"
        [events]="visibleEvents()"
        [settings]="settings()"
        [emptyMessage]="emptyMessage()"
        (eventClick)="onEventClicked($event)"
      />
    }
  }
</div>
